import { useEffect, useState } from "react";

import PropTypes from "prop-types";

// import Mui components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

// import mui icons
import ViewWeekIcon from "@mui/icons-material/ViewWeek";

import { useSelector, useDispatch } from "react-redux";
import { loadOverallRemovedKpiListState, loadSecondaryRemovedKpiListState, loadAgreementRemovedKpiListState, loadClaimsRemovedKpiListState, loadJustRightRemovedKpiListState, loadFragranceMetricsRemovedKpiListState, loadPreferenceRemovedKpiListState } from "store/features/analysisKpiSlice";

function VariableVisibility({ mappings = [], moduleName = "overall", view = "chart", disabled = false, pageName = "" }) {
    const position = {
        correlation: {
            top: "-35px",
            right: "-93px ",
        },
        overall: {
            top: "-26px",
            right: "-98px ",
        },
        agreement: {
            top: "-20px",
            right: "-96px ",
        },
        secondary: {
            top: "-26px",
            right: "-98px ",
        },
        claims: {
            top: "-19px",
            right: "-95px ",
        },
        itm: {
            top: "10px",
            right: "-75px ",
        },
        justRight: {
            top: "-19px",
            right: "-95px ",
        },
        fragranceMetrics: {
            top: "-30px",
            right: "-95px ",
        },
        fragranceMetricsTable: {
            top: "135px",
            right: "-99px ",
        },
        preference: {
            top: "-23px",
            right: "-95px ",
        },
    };

    const dispatch = useDispatch();
    const productColumnVisibility = useSelector((state) => state.productsInfoStore.productsVisibility);
    const removedKpiStoreState = useSelector((state) => state.analysisKpiStore[`${moduleName}RemovedKpiList`]);
    const dynamicTitle = pageName === "fragrance" ? "Variable Visibility" : "Variable KPI Visibility";
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();     
    const [removedKpi, setRemovedKpi] = useState([]);
    const isItmShown = useSelector((state) => state.analysisResultsStore.isItmDataShown);

    const [openColumnVisibilityDialogue, setOpenColumnVisibilityDialogue] = useState(false);

    const btnColorCode = view === "chart" ? "#005EEF" : "#9c27b0";
    const btnBorderColorCode = view === "chart" ? "1px solid #005EEF" : "1px solid #9c27b0";

    const handleColumnVisibilityDialogueClick = () => {
        setOpenColumnVisibilityDialogue((prev) => !prev);
    };

    const handleColumnVisibilityDialogueClickAway = () => {
        setOpenColumnVisibilityDialogue(false);
    };

    const renderRemovedListCheckboxes = () => {
        const uniqueDisplayLabel = Array.from(new Set(mappings.map((ele) => ele.displayLabel)));
        return uniqueDisplayLabel.map((label, i) => {
            const dpObj = mappings.filter((ele) => ele.displayLabel === label) ?? {};
            const value = dpObj.map((ele) => ele.backendVariable).join(",");
            let isChecked = true;
            if (isHairCare || moduleName === "overall") {
                isChecked = !removedKpiStoreState.includes(value);
            } else {
                isChecked = !removedKpiStoreState.flatMap((item) => item.split(",")).includes(value);
            }
            const key = i + 1;
            return (
                <FormControlLabel
                    key={key}
                    sx={{
                        "& .MuiTypography-root": {
                            fontSize: 13,
                            marginLeft: "10px",
                        },
                    }}
                    style={{
                        margin: "0px 0px 10px 0px",
                        padding: "3px 0px",
                    }}
                    className={`radio_${label.replace(/\s+/g, "").toLowerCase()}`}
                    checked={isChecked}
                    control={
                        <Switch
                            color={view === "chart" ? "primary" : "secondary"}
                            size="small"
                            onChange={(e) => handleShowHideKpi(e, value)}
                        />
                    }
                    label={label}
                />
            );
        });
    };
    useEffect(() => {
        setRemovedKpi(removedKpiStoreState);
    }, [removedKpiStoreState]);

    const handleShowHideKpi = (e, kpi) => {
        const checked = e.target.checked;
        const targetValue = kpi;
        let arrSet = new Set(removedKpi);
        if (!checked) {
            arrSet.add(targetValue);
            
        } else {
            // arrSet.delete(targetValue);
            arrSet = new Set(
                [...arrSet].filter(item => !item.includes(targetValue))
            );
        }

        setRemovedKpi(Array.from(arrSet));
        if (moduleName === "overall") {
            dispatch(loadOverallRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "secondary") {
            dispatch(loadSecondaryRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "agreement") {
            dispatch(loadAgreementRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "claims") {
            dispatch(loadClaimsRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "justRight") {
            dispatch(loadJustRightRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "fragranceMetrics") {
            dispatch(loadFragranceMetricsRemovedKpiListState(Array.from(arrSet)));
        } else if (moduleName === "preference") {
            dispatch(loadPreferenceRemovedKpiListState(Array.from(arrSet)));
        }
    };

    const list = () => {
        return (
            <div style={{ width: "100%" }}>
                <p
                    style={{ backgroundColor: view === "chart" ? "#005EEF" : "#9c27b0", fontSize: "0.67em", fontWeight: "bold", margin: "0.75em 0" }}
                    className="px-4 py-2 color-white"
                >
                    {dynamicTitle}
                </p>
                <div
                    className="px-2 mt-1"
                    style={{
                        height: 400,
                        overflow: "auto",
                        background: "linear-gradient(0deg, rgba(126,168,233,1) 0%, rgba(255,255,255,1) 100%)",
                    }}
                >
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>{renderRemovedListCheckboxes()}</FormGroup>
                    </FormControl>
                </div>
            </div>
        );
    };

    return (
        <ClickAwayListener
            mouseEvent="onMouseDown"
            touchEvent="onTouchStart"
            onClickAway={handleColumnVisibilityDialogueClickAway}
        >
            <div
                style={{
                    position: "relative",
                }}
            >
                {isItmShown && moduleName === "overall" ? (
                    <Button
                        style={{
                            ...position["itm"],
                            float: " right ",
                            clear: " both ",
                            rotate: "-90deg ",
                            background: "#005EEF ",
                            textTransform: " capitalize ",
                            padding: "3px 15px ",
                            border: "1px solid #005EEF ",
                            zIndex: "6 ",
                            fontWeight: "500 ",
                            fontSize: "0.8125rem ",
                            lineHeight: "1.75 ",
                            borderRadius: "0px 0px 2px 0px ",
                            letterSpacing: "0.02857em ",
                            color: "#fff ",
                        }}
                        onClick={handleColumnVisibilityDialogueClick}
                        startIcon={<ViewWeekIcon />}
                        disabled={disabled}
                    >
                        Variables Visibility
                    </Button>
                ) : (
                    <Button
                        style={{
                            ...position[moduleName],
                            float: " right ",
                            clear: " both ",
                            rotate: "-90deg ",
                            backgroundColor: disabled ? "rgba(0, 0, 0, 0.16)" : btnColorCode,
                            textTransform: " capitalize ",
                            padding: "3px 15px ",
                            border: disabled ? "1px solid rgba(0, 0, 0, 0.1)" : btnBorderColorCode,
                            zIndex: "6 ",
                            fontWeight: "500 ",
                            fontSize: "0.8125rem ",
                            lineHeight: "1.75 ",
                            borderRadius: moduleName === "fragranceMetricsTable" ? "0px" : "0px 0px 5px 0px ",
                            letterSpacing: "0.02857em ",
                            color: disabled ? "rgba(0, 0, 0, 0.26)" : "#fff ",
                        }}
                        onClick={handleColumnVisibilityDialogueClick}
                        startIcon={<ViewWeekIcon />}
                        disabled={disabled}
                    >
                        Variables Visibility
                    </Button>
                )}
                {openColumnVisibilityDialogue && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 75,
                            zIndex: 10,
                            bgcolor: "background.paper",
                            width: 350,
                            // height: 460,
                            maxHeight: 460,
                            height: "max-content",
                            boxSizing: "border-box",
                            right: 0,
                            overflow: "hidden",
                            boxShadow: "0px 20px 20px -10px #727272",
                        }}
                        style={{
                            borderRadius: 5,
                        }}
                    >
                        {productColumnVisibility && list()}
                    </Box>
                )}
            </div>
        </ClickAwayListener>
    );
}

// Typechecking props for the OverallKpi
VariableVisibility.propTypes = {
    mappings: PropTypes.array,
    moduleName: PropTypes.string,
    view: PropTypes.string,
    disabled: PropTypes.bool,
    pageName: PropTypes.string
};

export default VariableVisibility;
